import classnames from 'classnames';
import invariant from 'invariant';
import { forwardRef, useContext } from 'react';

import { AccordionContext } from '../Accordion.types';
import { AccordionItemContext } from '../AccordionItem/AccordionItem.types';

import styles from './AccordionContent.module.scss';
import { AccordionContentProps } from './AccordionContent.types';

export const AccordionContent = forwardRef<HTMLDivElement, AccordionContentProps>(
  ({ containerClassName, className, children, ...props }, ref) => {
    const accordionContext = useContext(AccordionContext);
    const itemContext = useContext(AccordionItemContext);
    invariant(accordionContext, 'AccordionTrigger must be used within AccordionItem');

    return (
      <div
        className={classnames(styles.content, containerClassName, {
          [styles.open]: itemContext.isOpen,
        })}
        ref={ref}
      >
        <div className={classnames({ [styles.withSeparators]: accordionContext.withSeparators })}>
          <div className={classnames(styles.children, className)} {...props}>
            {children}
          </div>
        </div>
      </div>
    );
  }
);
